import React from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';
import { IconButton } from '@mui/material';

/*
    actions = [{
        Icon,
        onClick
        color ??? (TODO: USE REACT-ICONS)
    }]
*/
const DataTableDocumentActions = ({
    actions
}) => {

    return (
        <div style={{ display: 'flex', gap: '.5rem' }}>
            {actions.map((action) => (
                <IconButton color={action.color} onClick={action.onClick} key={v4()}>
                    {<action.Icon />}
                </IconButton>
            ))}
        </div>
    );
};

DataTableDocumentActions.propTypes = {
    actions: PropTypes.arrayOf(PropTypes.shape({
        Icon: PropTypes.elementType.isRequired,
        onClick: PropTypes.func.isRequired,
        color: PropTypes.string
    })).isRequired
};

export default DataTableDocumentActions;